<template>
  <div class="row">
    <div class="col-md-12">
      <div class="showentries mb-3">
        <label
          >Show
          <select>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          entries
        </label>
      </div>
      <div class="table-responsive">
        <a-table
          class="stripped table-hover"
          :columns="columns"
          :data-source="data"
        >
          <template #bodyCell="{ column, record }">
            <!-- <template v-if="column.key === 'Status'">
              <div class="text-center">
                <div class="dropdown action-label">
                  <a
                    class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                    href="javascript:;"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i :class="record.class"></i>
                    {{ record.Status }}
                  </a>
                  <div class="dropdown-menu dropdown-menu-right">
                    <a class="dropdown-item" href="javascript:;"
                      ><i class="fa-regular fa-circle-dot text-danger"></i> Pending</a
                    >
                    <a class="dropdown-item" href="javascript:;"
                      ><i class="fa-regular fa-circle-dot text-success"></i> Approved</a
                    >
                    <a class="dropdown-item" href="javascript:;"
                      ><i class="fa-regular fa-circle-dot text-info"></i> Returned</a
                    >
                  </div>
                </div>
              </div>
            </template>
            <template v-if="column.key === 'action'">
              <div class="text-end">
                <div class="dropdown dropdown-action">
                  <a
                    href="javascript:;"
                    class="action-icon dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    ><i class="material-icons">{{ record.action }}</i></a
                  >
                  <div class="dropdown-menu dropdown-menu-right">
                    <a
                      class="dropdown-item"
                      href="javascript:;"
                      data-bs-toggle="modal"
                      data-bs-target="#edit_asset"
                      ><i class="fa-solid fa-pencil m-r-5"></i> Edit</a
                    >
                    <a
                      class="dropdown-item"
                      href="javascript:;"
                      data-bs-toggle="modal"
                      data-bs-target="#delete_asset"
                      ><i class="fa-regular fa-trash-can m-r-5"></i> Delete</a
                    >
                  </div>
                </div>
              </div>
            </template> -->
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>
<script>
import MyAssetService from "@/services/MyAssetService";

const columns = [
  {
    title: "Id ",
    dataIndex: "id",

    sorter: {
      compare: (a, b) => {
        a = a.id;
        b = b.id;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Asset Type",
    dataIndex: "asset_type",
    sorter: {
      compare: (a, b) => {
        a = a.asset_type.toLowerCase();
        b = b.asset_type.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Asset ID",
    dataIndex: "asset_id",
    sorter: {
      compare: (a, b) => {
        a = a.asset_id.toLowerCase();
        b = b.asset_id.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Product Name",
    dataIndex: "product_name",
    sorter: {
      compare: (a, b) => {
        a = a.product_name.toLowerCase();
        b = b.product_name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Asset Serial No & Pin",
    dataIndex: "asset_serial_no_pin",
    sorter: {
      compare: (a, b) => {
        a = a.asset_serial_no_pin.toLowerCase();
        b = b.asset_serial_no_pin.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Assigned By",
    dataIndex: "assigned_by_name",
    sorter: {
      compare: (a, b) => {
        a = a.assigned_by_name.toLowerCase();
        b = b.assigned_by_name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Assigned To",
    dataIndex: "assigned_to_name",
    sorter: {
      compare: (a, b) => {
        a = a.assigned_to_name.toLowerCase();
        b = b.assigned_to_name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Assigned Date",
    dataIndex: "issuance_date",
    sorter: {
      compare: (a, b) => {
        a = a.issuance_date.toLowerCase();
        b = b.issuance_date.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  // {
  //   title: "Status",
  //   dataIndex: "Status",
  //   key: "Status",
  //   class: "text-center",
  //   sorter: {
  //     compare: (a, b) => {
  //       a = a.Status.toLowerCase();
  //       b = b.Status.toLowerCase();
  //       return a > b ? -1 : b > a ? 1 : 0;
  //     },
  //   },
  // },

  // {
  //   title: "Action",
  //   key: "action",
  //   sorter: true,
  //   class: "text-end",
  // },
];
// const data = [
//   {
//     AssetUser: "Richard Miles",
//     AssetName: "Dell Laptop",
//     AssetId: "#AST-0001",
//     PurchaseDate: "5 Jan 2023",
//     Warrenty: "12 Months",
//     WarrentyEnd: "5 Jan 2023",
//     Amount: "$1215",
//     Status: "Pending",
//     action: "more_vert",
//     class: "fa-regular fa-circle-dot text-danger",
//   },
//   {
//     AssetUser: "John Doe",
//     AssetName: "Seagate Harddisk",
//     AssetId: "#AST-0002",
//     PurchaseDate: "14 Jan 2023",
//     Warrenty: "12 Months",
//     WarrentyEnd: "14 Jan 2023",
//     Amount: "$300",
//     Status: "Approved",
//     action: "more_vert",
//     class: "fa-regular fa-circle-dot text-success",
//   },
//   {
//     AssetUser: "John Smith",
//     AssetName: "Canon Portable Printer",
//     AssetId: "#AST-0003",
//     PurchaseDate: "14 Jan 2023",
//     Warrenty: "12 Months",
//     WarrentyEnd: "14 Jan 2023",
//     Amount: "$2500",
//     Status: "Returned",
//     action: "more_vert",
//     class: "fa-regular fa-circle-dot text-info",
//   },
//   {
//     AssetUser: "Mike Litorus",
//     AssetName: "Dell Laptop",
//     AssetId: "#AST-0004",
//     PurchaseDate: "5 Jan 2023",
//     Warrenty: "12 Months",
//     WarrentyEnd: "5 Jan 2023",
//     Amount: "$1215",
//     Status: "Pending",
//     action: "more_vert",
//     class: "fa-regular fa-circle-dot text-danger",
//   },
//   {
//     AssetUser: "Wilmer Deluna",
//     AssetName: "Seagate Harddisk",
//     AssetId: "#AST-0005",
//     PurchaseDate: "14 Jan 2023",
//     Warrenty: "12 Months",
//     WarrentyEnd: "14 Jan 2023",
//     Amount: "$300",
//     Status: "Approved",
//     action: "more_vert",
//     class: "fa-regular fa-circle-dot text-success",
//   },
//   {
//     AssetUser: "Jeffrey Warden",
//     AssetName: "Canon Portable Printer",
//     AssetId: "#AST-0006",
//     PurchaseDate: "14 Jan 2023",
//     Warrenty: "12 Months",
//     WarrentyEnd: "14 Jan 2023",
//     Amount: "$2500",
//     Status: "Returned",
//     action: "more_vert",
//     class: "fa-regular fa-circle-dot text-info",
//   },
//   {
//     AssetUser: "Bernardo Galaviz",
//     AssetName: "Dell Laptop",
//     AssetId: "#AST-0007",
//     PurchaseDate: "5 Jan 2023",
//     Warrenty: "12 Months",
//     WarrentyEnd: "5 Jan 2023",
//     Amount: "$1215",
//     Status: "Pending",
//     action: "more_vert",
//     class: "fa-regular fa-circle-dot text-danger",
//   },
//   {
//     AssetUser: "Lesley Grauer",
//     AssetName: "Seagate Harddisk",
//     AssetId: "#AST-0008",
//     PurchaseDate: "14 Jan 2023",
//     Warrenty: "12 Months",
//     WarrentyEnd: "14 Jan 2023",
//     Amount: "$300",
//     Status: "Approved",
//     action: "more_vert",
//     class: "fa-regular fa-circle-dot text-success",
//   },
//   {
//     AssetUser: "Jeffery Lalor",
//     AssetName: "Canon Portable Printer",
//     AssetId: "#AST-0009",
//     PurchaseDate: "14 Jan 2023",
//     Warrenty: "12 Months",
//     WarrentyEnd: "14 Jan 2023",
//     Amount: "$2500",
//     Status: "Returned",
//     action: "more_vert",
//     class: "fa-regular fa-circle-dot text-info",
//   },
//   {
//     AssetUser: "Loren Gatlin",
//     AssetName: "Dell Laptop",
//     AssetId: "#AST-0010",
//     PurchaseDate: "5 Jan 2023",
//     Warrenty: "12 Months",
//     WarrentyEnd: "5 Jan 2023",
//     Amount: "$1215",
//     Status: "Pending",
//     action: "more_vert",
//     class: "fa-regular fa-circle-dot text-danger",
//   },
//   {
//     AssetUser: "Tarah Shropshire",
//     AssetName: "Seagate Harddisk",
//     AssetId: "#AST-0011",
//     PurchaseDate: "14 Jan 2023",
//     Warrenty: "12 Months",
//     WarrentyEnd: "14 Jan 2023",
//     Amount: "$300",
//     Status: "Approved",
//     action: "more_vert",
//     class: "fa-regular fa-circle-dot text-success",
//   },
//   {
//     AssetUser: "Catherine Manseau",
//     AssetName: "Canon Portable Printer",
//     AssetId: "#AST-0012",
//     PurchaseDate: "14 Jan 2023",
//     Warrenty: "12 Months",
//     WarrentyEnd: "14 Jan 2023",
//     Amount: "$2500",
//     Status: "Returned",
//     action: "more_vert",
//     class: "fa-regular fa-circle-dot text-info",
//   },
// ];
export default {
  data() {
    return {
      columns,
      data: [],
    };
  },
  async created() {
    try {
      const response = await MyAssetService.getAssets();
      this.data = response.data;
    } catch (error) {
      console.log("error fetching data", error);
    }
  },
};
</script>
